import React, {useState} from 'react';
import {AuthenticatedTemplate, UnauthenticatedTemplate, useAccount, useMsal} from "@azure/msal-react";
import {loginRequest} from "../../authConfig";
import {Link, useLocation} from "react-router-dom";
import {
    MDBBadge,
    MDBBtn,
    MDBModal,
    MDBModalBody,
    MDBModalContent,
    MDBModalDialog,
    MDBModalFooter,
    MDBModalHeader,
    MDBModalTitle
} from 'mdb-react-ui-kit';
import {JOB_LIST} from '../../testing/TestingDataSH26';

export function EmployeeView() {
    const {instance} = useMsal();
    const account = useAccount();

    const [centredModal, setCentredModal] = useState(false);
    const toggleShow = () => setCentredModal(!centredModal);

    const loginRedirect = () => {
        instance.loginRedirect(loginRequest).catch((error) => console.log(error));
    };

    const employee = useLocation().state
    const jobIDs = employee.jobs

    function getJobFromId(id) {
       
        return JOB_LIST.filter(function (job) {
            return job.id === id;
        })
    }

    function DisplayJobs() {
        const returnInfo = [];
        const numberJobs = jobIDs.length;

        if (numberJobs === 0) {
            returnInfo.push(
                <div>
                    <p> {employee.name} hasn't started working on any jobs yet.</p>
                </div>
            )
        } else {
            for (const key in employee.jobs) {
               
                const jobInfo = getJobFromId(employee.jobs[key]);
                
                returnInfo.push(
                    <div>
                        <div className="list-section m-3">
                            <h4 className="list-section-header"> Job #{jobInfo[0].id} </h4>
                            <Link to={"/management/jobs/view"} state={jobInfo[0]}>
                                <button className="btn btn-primary list-section-btn float-right"> View Details</button>
                            </Link>
                            <p className="list-section-date-time"> {jobInfo[0].name} </p>

                            <br/><br/>

                        </div>

                    </div>
                )
            }
        }
        return returnInfo;
    }


    function ChangeStatus(props) {
        const status = employee.employeeStatus;
        const returnInfo = [];

        if (status === "EX") {
            return returnInfo;
        } else {
            returnInfo.push(
                <div>
                    <div className="list-section">
                        <h3> Mark {employee.name} as ex-employee</h3>
                        <hr/>
                        <br/>

                        <button onClick={toggleShow} className="btn btn-secondary"> Change employment status</button>

                        <MDBModal tabIndex='-1' show={centredModal} setShow={setCentredModal}>
                            <MDBModalDialog centered>
                                <MDBModalContent>
                                    <MDBModalHeader>
                                        <MDBModalTitle>Confirmation</MDBModalTitle>
                                        <MDBBtn className='btn-close' color='none' onClick={toggleShow}></MDBBtn>
                                    </MDBModalHeader>
                                    <MDBModalBody>
                                        <p>
                                            Confirm unemployement of employee {employee.name}
                                        </p>
                                    </MDBModalBody>
                                    <MDBModalFooter>
                                        <button className='btn-secondary' color='secondary' onClick={toggleShow}>
                                            Close
                                        </button>
                                        <button> Confirm</button>
                                    </MDBModalFooter>
                                </MDBModalContent>
                            </MDBModalDialog>
                        </MDBModal>
                    </div>

                    <div className="page-break"></div>
                </div>
            )
        }


        return returnInfo;
    }


    return (
        <div>
            <UnauthenticatedTemplate>
                <h5 className="no-access-message"> Sorry, you don't have access to this page! </h5>
            </UnauthenticatedTemplate>

            <AuthenticatedTemplate>
                <div className="page-title-sh26">
                    <h1>Details for {employee.name}
                    </h1>
                </div>
                <div className="centered align-items-center w-100">
                    <h5>Employee ID: #{employee.id}</h5>
                    <h5 className="mb-0"><MDBBadge pill className='info_float heading-float mt-0'
                                                   color='info_float'> {employee.popup} </MDBBadge></h5>
                </div>
                <hr/>

                <div className="page-break"></div>

                <div className="list-section">
                    <h3> Employee Details </h3>
                    <hr/>
                    <p>Employee name: {employee.name}</p>
                    <p>Employee email: {employee.email}</p>
                    <p>Employee phone number: {employee.phoneNumber}</p>
                    <p>Employee job title: {employee.jobTitle}</p>
                    <p>Employee start date: {employee.dates.dateStarted}</p>

                </div>

                <div className="page-break"></div>

                <div className="list-section">
                    <h3> {employee.name}'s jobs </h3>
                    <hr/>
                    <br/>
                    {DisplayJobs()}
                </div>

                <div className="page-break"></div>

                <ChangeStatus/>
            </AuthenticatedTemplate>
        </div>
    );
}
